import { createHeroQuery } from '@hcr/api/optimizely'

import { HTTP_CONFIG } from '../../../../configs'

export const useHeroQuery = createHeroQuery(HTTP_CONFIG.API.Optimizely.url)
